import React, { Component } from 'react';
import { BigNumber, ethers } from 'ethers';
import { getChainIdFromShortName, getProviderWithChainId, initProvider, MiningPoolAbi, tokenAbi, zeroAddress } from '../../utils/config';
import { Contract, Provider } from 'ethers-multicall';
import moment from 'moment-timezone';
import { eventBus } from '../../utils/tool';
import { getIpfsText } from '../../utils/ipfs';
import { connect } from "react-redux"
import store from '../../store';
import { withTranslation } from 'react-i18next';
import { getWalletSnapshot, restoreWallet } from '../../utils/walletProviders';

import copy from 'copy-to-clipboard';


// import '@sweetalert2/theme-dark/dark.scss';
import StakeModal from './components/StakeModal/index'
import IpfsPanel from './components/IpfsPanel/index'
import InviteConfirmModal from './components/InviteConfirmModal/index'
import WhitelistModal from './components/WhitelistModal/index'
import NftStakingConsole from '../StakingConsole/NftStakingConsole';
import ConsoleDialog from '../StakingConsole/ConsoleDialog';
import ConsoleToast from '../StakingConsole/ConsoleToast';
import { mapStakingError } from '../StakingConsole/errorMessages';
import { formatTokenAmount } from '../StakingConsole/formatAmount';
import { mapWithConcurrency, nftMetadataCache, normalizeNftUri, readInlineMetadata, shapeNftMetadata } from '../StakingConsole/nftMetadata';
import { loadOwnedTokenIds, loadStakedTokenIds } from '../StakingConsole/ownedTokenIds';
import TransactionSuccessDialog from '../StakingConsole/TransactionSuccess';
import { waitForTransaction } from '../StakingConsole/transactionFeedback';
import { getSelectedWalletEthersProvider } from '../../utils/selectedWalletProvider';
import { buildEmergencyRewardWithdrawPlan, buildEmergencyWithdrawPlan, buildNftClaimPlan, buildNftWithdrawPlan, buildSetEmergencyWithdrawPlan, buildStopRewardPlan, isDuplicateManualNft, isManualNftOwner, mapNftTokenIdList, parseManualNftTokenId } from './transactionPlan';
import { getRewardClaimAudit, getRewardWithdrawalProtection, MAX_EARLY_WITHDRAWAL_AUDIT_USERS } from '../StakingConsole/stakingLimits';

moment.tz.setDefault('UTC') // global style

const createDisplayError = (reason) => Object.assign(new Error(reason), { reason })
const NFT_READ_TIMEOUT_MS = 12000

export const stakingAssetInfoCache = {
    nft: new Map(),
    token: new Map(),
    pair: new Map(),
}

const assetInfoCacheKey = (chainId, address) => `${chainId}:${(address || '').toLowerCase()}`

const getPoolReadErrorKind = (error) => {
    const message = [
        error?.message,
        error?.reason,
        error?.error?.message,
    ].filter(Boolean).join(' ').toLowerCase()
    return /timeout|timed out/.test(message) ? 'timeout' : 'read'
}

const withRequestTimeout = (request, timeoutMs = NFT_READ_TIMEOUT_MS) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('NFT read request timed out')), timeoutMs)
    Promise.resolve(request).then(
        (value) => {
            clearTimeout(timer)
            resolve(value)
        },
        (error) => {
            clearTimeout(timer)
            reject(error)
        },
    )
})

const isOptionalInviterMethodUnavailable = (error) => {
    const message = [
        error?.message,
        error?.reason,
        error?.error?.message,
    ].filter(Boolean).join(' ').toLowerCase()
    const data = error?.data ?? error?.error?.data

    if (/429|403|rate limit|timeout|network error|server error|failed to fetch|missing response/.test(message)) {
        return false
    }
    if (/is not a function|function selector was not recognized|could not decode result data|insufficient data/.test(message)) {
        return true
    }
    return error?.code === 'CALL_EXCEPTION' && (!data || data === '0x') && !error?.reason
}

export class StakingOne extends Component {
    fetchRequestVersion = 0
    countdownTimerContext = null
    initialWalletRestorePending = false
    isComponentMounted = false
    lastWalletChainId = null

    state = {
        chain: '', // 公链
        contract: '', // 矿池地址
        account: '',
        chainId: 0,
        nftAddress: '',
        poolDataError: '',
        ipfsInfo: {},
        stakeTokenInfo: {},
        rewardTokenInfo: {},
        stakeTokenInfoLoading: true,
        rewardTokenInfoLoading: true,
        poolInfo: {},
        showStakeModal: false,
        swalProps: {},
        reawardLoading: false,// 领取奖励的loading
        currentProvider: null,
        stopRewardLoading: false, // 停止质押的loading
        enableForceWithdrawLoading: false, // 强制解除质押的loading
        showIpfsPanel: false, // 展示ipfs信息
        countdown: {
            type: 0,
            ct: '00:00:00' // 时 分 秒
        },
        showInviteConfirmModal: false, // 展示确认邀请modal
        showWhitelistModal: false, // 设置白名单
        params: {},
        urlPath: '', // 当前的路径 主机+域名+#+hash
        invitorList: [], // 当前用户的邀请人列表信息
        invitorTotalCount: 0,
        perPage: 10,
        isAdmin: false, // 是否是管理员
        stakeUserList: [], // 质押用户列表
        adminInfo: {}, // 管理员信息,
        rewardClaimAudit: { status: 'idle', canWithdrawEarly: false },
        networkName: '',
        walletNfts: undefined,
        manualNfts: [],
        stakedNftIds: undefined,
        stakedNftsLoading: false,
        nftMetadataById: {},
        unstakingTokenIds: {},
        emergencyWithdrawLoading: false,
        consoleToast: { show: false, message: '', tone: 'success' },
    }

    async initProvider(requireSelectedWallet = false) {
        let provider = null
        const chainId = this.state.chainId
        const wallet = getWalletSnapshot()
        if (wallet.account && wallet.provider) {
            try {
                const hexChainId = await wallet.provider.request({ method: 'eth_chainId' })
                const cid = parseInt(BigNumber.from(hexChainId).toString())
                if (chainId === cid) {
                    provider = new ethers.providers.Web3Provider(wallet.provider)
                }
            } catch (error) {
                if (requireSelectedWallet) throw error
            }
        }
        if (requireSelectedWallet && !provider) {
            throw new Error('Selected wallet is unavailable or connected to the wrong network')
        }
        if (!provider) {
            provider = getProviderWithChainId(chainId)
        }

        return provider
    }

    applyInitialWallet(wallet = {}) {
        if (!this.isComponentMounted) return
        const latestWallet = getWalletSnapshot()
        const resolvedWallet = latestWallet.account || latestWallet.provider ? latestWallet : wallet
        const initialAccount = resolvedWallet.account || this.props.account || ''
        this.lastWalletChainId = resolvedWallet.chainId ?? null
        this.setState({
            account: initialAccount,
            currentProvider: resolvedWallet.provider || null,
            swalProps: {
                show: false,
                title: '',
                text: '',
            }
        }, () => this.fetchData())
    }

    componentDidMount() {
        this.isComponentMounted = true
        this.walletConnectHandler = this.walletConnect.bind(this)
        eventBus.addListener("walletConnect", this.walletConnectHandler)
        const wallet = getWalletSnapshot()
        if (wallet.account && wallet.provider) {
            this.initialWalletRestorePending = false
            this.applyInitialWallet(wallet)
            return
        }

        this.initialWalletRestorePending = true
        Promise.resolve()
            .then(() => restoreWallet())
            .catch(() => getWalletSnapshot())
            .then((restoredWallet) => {
                if (!this.isComponentMounted) return
                this.initialWalletRestorePending = false
                this.applyInitialWallet(restoredWallet)
            })
    }



    async getNftInfo(nftAddress, provider, chainId, currentWallet) {
        const cacheKey = assetInfoCacheKey(chainId, nftAddress)
        let staticInfo = stakingAssetInfoCache.nft.get(cacheKey)
        const token = new Contract(nftAddress, tokenAbi)
        const calls = []
        if (!staticInfo) {
            calls.push(token.name(), token.symbol(), token.totalSupply())
        }
        if (currentWallet) {
            calls.push(token.balanceOf(currentWallet))
        }
        let res = []
        if (calls.length > 0) {
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, chainId)
            res = await ethcallProvider.all(calls)
        }

        let resultIndex = 0
        if (!staticInfo) {
            staticInfo = {
                name: res[resultIndex++],
                symbol: res[resultIndex++],
                totalSupply: res[resultIndex++].toString(),
            }
            stakingAssetInfoCache.nft.set(cacheKey, staticInfo)
        }
        let balance = 0
        let balanceBigNumber = null
        if (currentWallet) {
            balanceBigNumber = res[resultIndex]
            balance = balanceBigNumber.toString()
        }
        return {
            ...staticInfo,
            address: nftAddress,
            balance,
            balanceBigNumber,
        }
    }
    async getTokenInfo(tokenAddress, provider, chainId, currentWallet, miningContract) {
        const cacheKey = assetInfoCacheKey(chainId, tokenAddress)
        let staticInfo = stakingAssetInfoCache.token.get(cacheKey)
        const token = new Contract(tokenAddress, tokenAbi)
        const calls = []
        if (!staticInfo) {
            calls.push(token.name(), token.symbol(), token.decimals(), token.totalSupply())
        }
        if (currentWallet) {
            calls.push(token.allowance(currentWallet, miningContract), token.balanceOf(currentWallet))
        }
        let res = []
        if (calls.length > 0) {
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, chainId)
            res = await ethcallProvider.all(calls)
        }

        let resultIndex = 0
        if (!staticInfo) {
            const decimals = parseInt(res[resultIndex + 2].toString())
            const totalSupply = res[resultIndex + 3].toString() / Math.pow(10, decimals)
            staticInfo = {
                name: res[resultIndex],
                symbol: res[resultIndex + 1],
                decimals,
                totalSupply,
            }
            resultIndex += 4
            stakingAssetInfoCache.token.set(cacheKey, staticInfo)
        }
        let allowance = 0
        let balance = 0
        let balanceBigNumber = null
        if (currentWallet) {
            allowance = res[resultIndex++].toString()
            balanceBigNumber = res[resultIndex]
            balance = balanceBigNumber.toString()
        }

        return {
            ...staticInfo,
            address: tokenAddress,
            allowance,
            balance,
            balanceBigNumber,
            isPairToken: false,
            token0Info: {},
            token1Info: {},
        }
    }

    async getPairTokenInfo(tokenAddress, provider, chainId) {
        const cacheKey = assetInfoCacheKey(chainId, tokenAddress)
        if (stakingAssetInfoCache.pair.has(cacheKey)) {
            return stakingAssetInfoCache.pair.get(cacheKey)
        }
        const fatTokenAbi = [
            'function token0() external view returns(address)',
            'function token1() external view returns(address)',
        ]
        let pairAddresses
        try {
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, chainId)
            const pairToken = new Contract(tokenAddress, fatTokenAbi)
            pairAddresses = await ethcallProvider.all([pairToken.token0(), pairToken.token1()])
        } catch (error) {
            const notPair = { isPairToken: false, token0Info: {}, token1Info: {} }
            if (isOptionalInviterMethodUnavailable(error)) {
                stakingAssetInfoCache.pair.set(cacheKey, notPair)
            }
            return notPair
        }

        const [token0Result, token1Result] = await Promise.allSettled([
            this.getTokenInfo(pairAddresses[0], provider, chainId, '', ''),
            this.getTokenInfo(pairAddresses[1], provider, chainId, '', ''),
        ])
        const pairInfo = {
            isPairToken: true,
            token0Info: token0Result.status === 'fulfilled'
                ? token0Result.value
                : { address: pairAddresses[0] },
            token1Info: token1Result.status === 'fulfilled'
                ? token1Result.value
                : { address: pairAddresses[1] },
        }
        stakingAssetInfoCache.pair.set(cacheKey, pairInfo)
        return pairInfo
    }

    async loadStakeTokenInfo({ address, provider, context }) {
        try {
            const stakeTokenInfo = await this.getNftInfo(address, provider, context.chainId, context.account)
            this.setStateForFetch(context, {
                stakeTokenInfo,
                stakeTokenInfoLoading: false,
            })
        } catch (_error) {
            this.setStateForFetch(context, {
                stakeTokenInfoLoading: false,
            })
        }
    }

    async loadRewardTokenInfo({ address, provider, context }) {
        try {
            const rewardTokenInfo = await this.getTokenInfo(address, provider, context.chainId, context.account, context.contract)
            this.setStateForFetch(context, {
                rewardTokenInfo,
                rewardTokenInfoLoading: false,
            }, () => {
                void this.loadRewardPairInfo({ address, provider, context })
            })
        } catch (_error) {
            this.setStateForFetch(context, {
                rewardTokenInfoLoading: false,
            })
        }
    }

    async loadRewardPairInfo({ address, provider, context }) {
        const pairInfo = await this.getPairTokenInfo(address, provider, context.chainId)
        if (!this.isFetchContextCurrent(context)) return
        this.setStateForFetch(context, {
            rewardTokenInfo: {
                ...this.state.rewardTokenInfo,
                ...pairInfo,
            },
        })
    }

    async loadOptionalInviterInfo(ethcallProvider, pool, context) {
        try {
            const inviterConfig = await this.readOptionalInviterConfig(ethcallProvider, pool, context)
            if (!inviterConfig || !this.isFetchContextCurrent(context)) return
            let invitorRewardPercentList = []
            if (inviterConfig.rewardPercentCount > 0) {
                const calls = Array.from(
                    { length: inviterConfig.rewardPercentCount },
                    (_item, index) => pool.invitorRewardPercentList(index),
                )
                const percentages = await ethcallProvider.all(calls)
                if (!this.isFetchContextCurrent(context)) return
                invitorRewardPercentList = percentages.map((item) => Number(item.toString()) / 100)
            }
            this.setStateForFetch(context, (state) => ({
                poolInfo: {
                    ...state.poolInfo,
                    inviterSupported: inviterConfig.supported,
                    enableInvitor: inviterConfig.enabled,
                    invitorRewardPercentListLength: inviterConfig.rewardPercentCount,
                    feeOfOpenInviter: inviterConfig.feeOfOpenInviter,
                    myInvitor: inviterConfig.myInvitor,
                    invitorRewardPercentList,
                },
            }), () => {
                if (inviterConfig.enabled) {
                    this.getInvitorList(1, context)
                }
            })
        } catch (_error) {
            // 邀请功能是可选能力，读取失败不能阻塞矿池主体。
        }
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        this.initialWalletRestorePending = false
        this.invalidateFetchData()
        this.stopCountdown()
        eventBus.removeListener("walletConnect", this.walletConnectHandler)
        this.countdownTimer && clearInterval(this.countdownTimer)
    }



    walletConnect(v) {
        if (this.initialWalletRestorePending) return
        const walletChainId = v?.chainId ?? null
        const account = v?.account || ''
        const currentProvider = account ? (v?.provider || getWalletSnapshot().provider || null) : null
        if (
            account === (this.state.account || '')
            && currentProvider === (this.state.currentProvider || null)
            && walletChainId === this.lastWalletChainId
        ) {
            return
        }
        this.invalidateFetchData()
        this.lastWalletChainId = walletChainId
        const accountState = {
            stakeTokenInfo: {},
            rewardTokenInfo: {},
            poolInfo: this.getPublicPoolInfo(),
            invitorList: [],
            invitorTotalCount: 0,
            stakeUserList: [],
            adminInfo: {},
            isAdmin: false,
            poolDataLoading: true,
            poolDataError: '',
            poolDataErrorKind: '',
            stakeTokenInfoLoading: true,
            rewardTokenInfoLoading: true,
            walletNfts: undefined,
            manualNfts: [],
            stakedNftIds: undefined,
            stakedNftsLoading: Boolean(account),
            nftMetadataById: {},
            unstakingTokenIds: {},
        }
        if (!account) {
            this.setState({
                account: '',
                currentProvider: null,
                ...accountState,
            }, () => this.fetchData())
            return
        }
        this.setState({
            account,
            currentProvider,
            ...accountState,
        }, () => this.fetchData())
    }
    getPublicPoolInfo() {
        return {
            ...this.state.poolInfo,
            pendingReward: 0,
            userStakedAmount: 0,
            userStakeAmountBigNumber: null,
            userExtendPownerAmount: 0,
            userCanWithdraw: false,
            unlockTime: 0,
            myInvitor: '',
        }
    }
    invalidateFetchData() {
        this.fetchRequestVersion += 1
    }
    getFetchContext({ account = this.state.account, chainId = this.state.chainId, contract = this.state.contract } = {}) {
        return {
            account: account || '',
            chainId,
            contract: (contract || '').toLowerCase(),
            requestVersion: this.fetchRequestVersion,
        }
    }
    isFetchContextCurrent(context) {
        return Boolean(context)
            && context.requestVersion === this.fetchRequestVersion
            && context.account === (this.state.account || '')
            && context.chainId === this.state.chainId
            && context.contract === (this.state.contract || '').toLowerCase()
    }
    setStateForFetch(context, patch, callback) {
        if (!this.isFetchContextCurrent(context)) return
        this.setState((state) => {
            if (!this.isFetchContextCurrent(context)) return null
            return typeof patch === 'function' ? patch(state) : patch
        }, () => {
            if (this.isFetchContextCurrent(context)) callback?.()
        })
    }
    stopCountdown(timerContext) {
        if (timerContext && timerContext !== this.countdownTimerContext) return
        if (this.countdownTimer) clearInterval(this.countdownTimer)
        this.countdownTimer = null
        this.countdownTimerContext = null
    }
    stopCountdownForDifferentPool(context) {
        const timerContext = this.countdownTimerContext
        if (!timerContext) return
        if (timerContext.chainId !== context.chainId || timerContext.contract !== context.contract) {
            this.stopCountdown(timerContext)
        }
    }
    startCountdown(context) {
        if (!this.isFetchContextCurrent(context)) return
        this.stopCountdown()
        const timerContext = {
            chainId: context.chainId,
            contract: context.contract,
            requestVersion: context.requestVersion,
        }
        this.countdownTimerContext = timerContext
        void this.calcCountdownInfo(timerContext)
        this.countdownTimer = setInterval(() => this.calcCountdownInfo(timerContext), 1000)
    }
    async readOptionalInviterConfig(ethcallProvider, pool, context) {
        try {
            const calls = [
                pool.enableInviter(),
                pool.lenOfInvitorRewardPercentList(),
                pool.feeOfOpenInviter(),
            ]
            if (context.account) {
                calls.push(pool._invitor(context.account))
            }
            const [enabled, rewardPercentCount, feeOfOpenInviter, currentInviter] = await ethcallProvider.all(calls)
            if (!this.isFetchContextCurrent(context)) return null
            return {
                supported: true,
                enabled: enabled === true || enabled?.toString?.() === 'true',
                rewardPercentCount: parseInt(rewardPercentCount?.toString?.() || '0'),
                feeOfOpenInviter: parseFloat(ethers.utils.formatEther(feeOfOpenInviter?.toString?.() || '0')),
                myInvitor: currentInviter && currentInviter.toLowerCase() !== zeroAddress.toLowerCase()
                    ? currentInviter
                    : '',
            }
        } catch (error) {
            if (!this.isFetchContextCurrent(context)) return null
            if (isOptionalInviterMethodUnavailable(error)) {
                return {
                    supported: false,
                    enabled: false,
                    rewardPercentCount: 0,
                    feeOfOpenInviter: 0,
                    myInvitor: '',
                }
            }
            throw error
        }
    }
    async fetchData() {
        const requestVersion = ++this.fetchRequestVersion
        // 获取url参数
        const query = new URL(window.location.href)
        console.log(query, 'aaa')
        const r = query.hash.replace('#/', '').split('/')
        const ps = r[1].split('?')
        let contract = ps[0]
        const hrefArr = (query.origin + '/' + query.hash).split('?')

        let params = {}
        if (ps.length > 0) {
            const queryParams = new URLSearchParams(ps[1])
            // 获取inviter
            const m = {}
            for (const [key, value] of queryParams.entries()) {
                m[key] = value || ''
            }
            params = m
        }
        // 获取代币信息
        // 如果当前钱包和选择的公链一致, 则使用当前的provider
        // 如果不一致, 则自动选择provider
        const chainId = getChainIdFromShortName(r[0])
        const context = {
            account: this.state.account || '',
            chainId,
            contract: contract.toLowerCase(),
            requestVersion,
        }
        this.stopCountdownForDifferentPool(context)


        this.setState({
            params,
            chain: r[0],
            contract,
            urlPath: hrefArr[0],
            poolDataLoading: true,
            poolDataError: '',
            poolDataErrorKind: '',
            stakeTokenInfoLoading: true,
            rewardTokenInfoLoading: true,
            nftMetadataById: {},
            chainId
        }, async () => {
            if (!this.isFetchContextCurrent(context)) return

            try {
                const provider = await this.initProvider()
                if (!this.isFetchContextCurrent(context)) return

                // 获取矿池信息
                let ethcallProvider = new Provider(provider)
                ethcallProvider = await initProvider(ethcallProvider, chainId)
                if (!this.isFetchContextCurrent(context)) return

                const pool = new Contract(contract, MiningPoolAbi)

            // 开始时间 结束时间 最大质押量 锁仓时间 apr 我的质押量 我的收益
            const calls1 = [
                pool.stakedToken(),
                pool.rewardToken(),
                pool.startBlock(),
                pool.bonusEndBlock(),
                pool.poolLimitPerUser(),
                pool.numberBlocksForUserLimit(),
                pool.lengthOflockTime(),
                pool.owner(),
                pool._baseURI(),
                pool.usercanemergencyWithdraw(), // 是否允许紧急提现
            ]


            if (context.account) {
                //  我的收益 我的质押量 当前能否提现 我的解锁时间
                calls1.push(pool.pendingReward(context.account))
                calls1.push(pool.userInfo(context.account))
                calls1.push(pool.getUserCanWithdraw(context.account))
                calls1.push(pool.getUnlockTime(context.account))
            }

            const res1 = await ethcallProvider.all(calls1)
            if (!this.isFetchContextCurrent(context)) return

            const miningInfo = {
                stakeToken: res1[0],
                rewardToken: res1[1],
                startTime: moment(parseInt(res1[2].toString()) * 1000),
                endTime: moment(res1[3].toString() * 1000),
                poolLimitPerUser: parseInt(res1[4].toString()),
                numberBlocksForUserLimit: parseInt(res1[5].toString()),
                deadline: moment((parseInt(res1[2].toString()) + parseInt(res1[5].toString())) * 1000),
                lockTime: parseInt(res1[6].toString()),
                owner: res1[7],
                inviterSupported: null,
                enableInvitor: false,
                ipfsKey: res1[8],
                allowMergencyWithdraw: res1[9],
                invitorRewardPercentListLength: 0,
                invitorRewardPercentList: [],
                feeOfOpenInviter: 0,
                pendingReward: res1[10] ? res1[10].toString() : '0',
                userStakedAmount: res1[11] ? res1[11].amount.toString() : '0',
                userStakeAmountBigNumber: res1[11] ? res1[11].amount : null, // 质押量的bigNumber
                userExtendPownerAmount: res1[11] ? res1[11].extendPower.toString() : '0',
                userCanWithdraw: res1[12] || false,
                unlockTime: res1[13] ? parseInt(res1[13].toString()) : 0,
                myInvitor: '',
            }

            console.log('miningInfo', miningInfo, 'miningInfo')

            const isAdmin = Boolean(context.account)
                && miningInfo.owner?.toLowerCase() === context.account.toLowerCase()
            const cachedStakeInfo = stakingAssetInfoCache.nft.get(assetInfoCacheKey(chainId, miningInfo.stakeToken))
            const cachedRewardInfo = stakingAssetInfoCache.token.get(assetInfoCacheKey(chainId, miningInfo.rewardToken))

            this.setStateForFetch(context, {
                poolInfo: miningInfo,
                isAdmin,
                rewardClaimAudit: { status: isAdmin ? 'idle' : 'not-owner', canWithdrawEarly: false },
                chainId,
                networkName: r[0],
                nftAddress: miningInfo.stakeToken,
                stakeTokenInfo: {
                    name: 'NFT',
                    symbol: 'NFT',
                    totalSupply: '0',
                    balance: '0',
                    balanceBigNumber: null,
                    ...cachedStakeInfo,
                    address: miningInfo.stakeToken,
                },
                rewardTokenInfo: {
                    name: '',
                    symbol: '',
                    decimals: 18,
                    totalSupply: 0,
                    allowance: '0',
                    balance: '0',
                    balanceBigNumber: null,
                    isPairToken: false,
                    token0Info: {},
                    token1Info: {},
                    ...cachedRewardInfo,
                    address: miningInfo.rewardToken,
                },
                stakeTokenInfoLoading: true,
                rewardTokenInfoLoading: true,
                poolDataLoading: false,
                poolDataError: '',
                poolDataErrorKind: '',
            }, () => {
                this.startCountdown(context)
                if (isAdmin) {
                    this.getStakeListForAdmin(1, context)
                }
                if (context.account) {
                    void this.loadWalletNfts(context)
                    void this.loadStakedNfts(context)
                }
            })

            void this.loadOptionalInviterInfo(ethcallProvider, pool, context)
            void this.loadStakeTokenInfo({
                address: miningInfo.stakeToken,
                provider,
                context,
            })
            void this.loadRewardTokenInfo({
                address: miningInfo.rewardToken,
                provider,
                context,
            })

            // 获取ipfs信息
            if (miningInfo.ipfsKey) {
                getIpfsText(miningInfo.ipfsKey)
                    .then(res => {
                        if (!this.isFetchContextCurrent(context)) return
                        console.log('ipfs信息', JSON.parse(res))
                        this.setStateForFetch(context, {
                            ipfsInfo: JSON.parse(res)
                        })
                        store.dispatch({
                            type: 'setMiningInfo',
                            value: JSON.parse(res)
                        })
                    })
            }
            } catch (error) {
                this.setStateForFetch(context, {
                    poolDataLoading: false,
                    poolDataError: mapStakingError(error, this.props.t),
                    poolDataErrorKind: getPoolReadErrorKind(error),
                    walletNfts: [],
                    stakedNftIds: [],
                    stakedNftsLoading: false,
                })
            }

        })



    }


    getNetworkErrorMessage() {
        return this.props.t('当前网络不匹配, 请连接CORE钱包').replace('{net}', this.state.networkName.toUpperCase())
    }

    checkNetwork({ silent = false } = {}) {
        if (this.state.chainId !== this.props.chainId) {
            if (!silent) {
                this.showMessageModal({
                    show: true,
                    title: this.props.t('错误'),
                    text: this.getNetworkErrorMessage(),
                })
            }
            return false
        }
        return true
    }

    handleErr(e) {
        this.showMessageModal({
            show: true,
            title: this.props.t('错误'),
            text: mapStakingError(e, this.props.t),
        })
    }

    async calcCountdownInfo(timerContext = this.countdownTimerContext) {
        if (timerContext && timerContext !== this.countdownTimerContext) return
        if (timerContext && (timerContext.chainId !== this.state.chainId || timerContext.contract !== (this.state.contract || '').toLowerCase())) {
            this.stopCountdown(timerContext)
            return
        }
        const now = moment()
        const { startTime, endTime, unlockTime } = this.state.poolInfo
        if (!startTime || !endTime) return

        this.setState({
            poolInfo: {
                ...this.state.poolInfo,
                unlockTime: (unlockTime - 1 > 0) ? unlockTime - 1 : 0
            }
        })
        let type = 1 // 1:开始倒计时 2:结束倒计时 3: 已结束
        // 倒计时
        let countdown = 0


        if (startTime.isAfter(endTime)) {
            type = 3
        } else if (now.isBefore(startTime)) {
            countdown = startTime.diff(now, 'seconds')
        } else if (now.isBefore(endTime) && now.isAfter(startTime)) {
            type = 2
            countdown = endTime.diff(now, 'seconds')
        } else if (now.isAfter(endTime)) {
            type = 3
        }

        // 倒计时文案
        let days = Math.floor(countdown / 86400)
        let hours = Math.floor((countdown - days * 86400) / 3600)
        let minutes = Math.floor((countdown - days * 86400 - hours * 3600) / 60)
        let seconds = Math.floor(countdown - days * 86400 - hours * 3600 - minutes * 60)
        days = days < 10 ? '0' + days : days
        hours = hours < 10 ? '0' + hours : hours
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        const countdownText = `${days}:${hours}:${minutes}:${seconds}`

        this.setState({
            countdown: {
                type,
                ct: countdownText,
            }
        })

    }

    async getStakeListForAdmin(page, fetchContext = this.getFetchContext()) {
        // 获取质押总量 当前质押总人数 当前质押总算力
        if (!fetchContext.account || !this.isFetchContextCurrent(fetchContext)) {
            return
        }
        // 获取下级列表
        const p = await this.initProvider()
        if (!this.isFetchContextCurrent(fetchContext)) return
        let ethcallProvider = new Provider(p)
        ethcallProvider = await initProvider(ethcallProvider, fetchContext.chainId)
        if (!this.isFetchContextCurrent(fetchContext)) return
        const pool = new Contract(fetchContext.contract, MiningPoolAbi)

        const calls1 = [pool.getUsersCount(), pool.getTotalPower(), pool.getTotalStakeAmount()]
        const res1 = await ethcallProvider.all(calls1)
        if (!this.isFetchContextCurrent(fetchContext)) return
        console.log('admin111', res1)
        const adminInfo = {
            userCount: parseInt(res1[0].toString()), // 质押总人数
            totalPower: res1[1].toString(), // 质押总算力
            totalStakeAmount: res1[2].toString(), // 质押总量
        }

        // 获取质押列表
        const perPage = this.state.perPage

        const calls2 = []
        for (let i = adminInfo.userCount - ((page - 1) * perPage) - 1; i >= 0; i--) {
            calls2.push(pool.getUserById(ethers.utils.parseUnits(i + '', 0)))
            if (calls2.length >= perPage) break
        }
        const list = await ethcallProvider.all(calls2)
        if (!this.isFetchContextCurrent(fetchContext)) return

        const arr = list.map(item => {
            // 已提升算力 已领取 质押数 奖励数 用户地址 邀请人
            return {
                invitor: item.invitor,
                userAddr: item.userAddr,
                stakedTokenAmount: item.stakeAmount.toString(),
                rewardTokenAmount: item.rewardAmount.toString(),
                claimedTokenAmount: item.hasBeenClaimdReward.toString(),
                extendPower: item.extendPower.toString(),
            }
        })
        console.log('第', page, '页信息', list, arr)

        this.setStateForFetch(fetchContext, {
            adminInfo,
            stakeUserList: arr,
        })

    }

    async getInvitorList(page, fetchContext = this.getFetchContext()) {
        if (!fetchContext.account || !this.isFetchContextCurrent(fetchContext)) {
            return
        }
        // 获取下级列表
        const p = await this.initProvider()
        if (!this.isFetchContextCurrent(fetchContext)) return
        let ethcallProvider = new Provider(p)
        ethcallProvider = await initProvider(ethcallProvider, fetchContext.chainId)
        if (!this.isFetchContextCurrent(fetchContext)) return

        // 获取下级总数, 用来分页
        // 按照倒序, 获取下级地址
        // 根据下级地址, 获取信息
        const pool = new Contract(fetchContext.contract, MiningPoolAbi)

        // 获取总数
        // 切片 获取信息
        const calls1 = [pool.inviterListsForUserTotal(fetchContext.account)]
        const res1 = await ethcallProvider.all(calls1)
        if (!this.isFetchContextCurrent(fetchContext)) return
        console.log('总数为', res1[0].toString())
        const total = res1[0].toString()
        // 分页
        const perPage = this.state.perPage

        const calls2 = []
        for (let i = total - ((page - 1) * perPage) - 1; i >= 0; i--) {
            calls2.push(pool.inviterListsForUserPage(fetchContext.account, ethers.utils.parseUnits(i + '', 0)))
            if (calls2.length >= perPage) break
        }
        const list = await ethcallProvider.all(calls2)
        if (!this.isFetchContextCurrent(fetchContext)) return

        const arr = list.map(item => {
            // 已提升算力 已领取 质押数 奖励数 用户地址 邀请人
            return {
                invitor: item.invitor,
                userAddr: item.userAddr,
                stakedTokenAmount: item.stakeAmount.toString(),
                rewardTokenAmount: item.rewardAmount.toString(),
                claimedTokenAmount: item.hasBeenClaimdReward.toString(),
                extendPower: item.extendPower.toString(),
            }
        })
        console.log('第', page, '页信息', list, arr)

        this.setStateForFetch(fetchContext, {
            invitorList: arr,
            invitorTotalCount: parseInt(total),
            perPage
        })




    }

    async enableForceWithdraw({ errorMode = 'global' } = {}) {
        const locallyOwnedError = errorMode === 'local'
        if (this.checkNetwork({ silent: locallyOwnedError }) === false) {
            if (locallyOwnedError) throw createDisplayError(this.getNetworkErrorMessage())
            return false
        }
        // 允许紧急撤离矿池
        const r = this.state.poolInfo.allowMergencyWithdraw ? false : true
        this.setState({
            enableForceWithdrawLoading: true
        })
        try {
            const p = await this.initProvider(true)
            const a = new ethers.Contract(this.state.contract, MiningPoolAbi, p.getSigner())
            const plan = buildSetEmergencyWithdrawPlan(r)
            const tx = await a[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            const successInfo = {
                title: this.props.t('紧急撤离设置成功'),
                description: r
                    ? this.props.t('用户现在可以使用紧急撤离。')
                    : this.props.t('用户紧急撤离权限已关闭。'),
                ...result,
            }
            if (!locallyOwnedError) this.showTransactionSuccess(successInfo)
            this.fetchData()
            return successInfo
        } catch (e) {
            if (!locallyOwnedError) this.handleErr(e)
            throw e
        } finally {
            this.setState({
                enableForceWithdrawLoading: false
            })
        }
    }

    async checkRewardClaimAudit(fetchContext = this.getFetchContext()) {
        if (!fetchContext.account || !this.isFetchContextCurrent(fetchContext)) {
            return { status: 'not-owner', canWithdrawEarly: false }
        }
        this.setStateForFetch(fetchContext, {
            rewardClaimAudit: { status: 'checking', canWithdrawEarly: false },
        })
        try {
            const provider = await this.initProvider()
            if (!this.isFetchContextCurrent(fetchContext)) return { status: 'stale', canWithdrawEarly: false }
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, fetchContext.chainId)
            const pool = new Contract(fetchContext.contract, MiningPoolAbi)
            const [countValue] = await ethcallProvider.all([pool.getUsersCount()])
            const userCount = Number(countValue.toString())
            let users = []
            if (userCount <= MAX_EARLY_WITHDRAWAL_AUDIT_USERS) {
                const calls = Array.from({ length: userCount }, (_item, index) => (
                    pool.getUserById(ethers.utils.parseUnits(String(index), 0))
                ))
                users = calls.length > 0 ? await ethcallProvider.all(calls) : []
            }
            const audit = getRewardClaimAudit({ userCount, users })
            this.setStateForFetch(fetchContext, { rewardClaimAudit: audit })
            return audit
        } catch (error) {
            const audit = { status: 'failed', canWithdrawEarly: false, error: mapStakingError(error, this.props.t) }
            this.setStateForFetch(fetchContext, { rewardClaimAudit: audit })
            return audit
        }
    }

    async withdrawRemindRewardTokens({ errorMode = 'global' } = {}) {
        const locallyOwnedError = errorMode === 'local'
        // 提取剩余奖励代币
        if (this.checkNetwork({ silent: locallyOwnedError }) === false) {
            if (locallyOwnedError) throw createDisplayError(this.getNetworkErrorMessage())
            return false
        }

        // 24 小时内仅当全部质押用户已领取奖励时允许提前提取。
        const protection = getRewardWithdrawalProtection({
            endTimeUnix: this.state.poolInfo.endTime.unix(),
            nowUnix: moment().unix(),
        })
        let canWithdraw = protection.isAvailable
        if (!canWithdraw) {
            const audit = await this.checkRewardClaimAudit()
            canWithdraw = audit.canWithdrawEarly
        }
        if (!canWithdraw) {
            // 弹出提示
            const countdown = protection.remainingSeconds
            const hours = Math.floor(countdown / 3600)
            const minutes = Math.floor((countdown - hours * 3600) / 60)
            const countdownText = `${hours} ${this.props.t('小时')} ${minutes} ${this.props.t('分钟')}`
            const message = this.props.t('距离矿池结束时间不足24小时, 剩余时间为 ') + countdownText
            if (locallyOwnedError) throw createDisplayError(message)
            this.showMessageModal({
                show: true,
                title: this.props.t('错误'),
                text: message
            })
            return false
        }

        this.setState({
            stopRewardLoading: true
        })
        try {
            const p = await this.initProvider(true)
            const token = new ethers.Contract(this.state.rewardTokenInfo.address, tokenAbi, p.getSigner())
            const balance = await token.balanceOf(this.state.contract)
            const balanceString = ethers.utils.formatUnits(balance, this.state.rewardTokenInfo.decimals)
            if (balance.isZero()) {
                throw createDisplayError(this.props.t('矿池内奖励代币余额为0'))
            }
            const a = new ethers.Contract(this.state.contract, MiningPoolAbi, p.getSigner())
            const plan = buildEmergencyRewardWithdrawPlan(balance)
            const tx = await a[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            const successInfo = {
                title: this.props.t('剩余奖励提取成功'),
                description: this.props.t('矿池中的剩余奖励代币已返回管理员钱包。'),
                amount: balanceString,
                symbol: this.state.rewardTokenInfo.symbol,
                amountLabel: this.props.t('提取数量'),
                ...result,
            }
            if (!locallyOwnedError) this.showTransactionSuccess(successInfo)
            return successInfo
        } catch (e) {
            if (!locallyOwnedError) this.handleErr(e)
            throw e
        } finally {
            this.setState({
                stopRewardLoading: false
            })
        }
    }

    async stopRewardLogic({ errorMode = 'global' } = {}) {
        const locallyOwnedError = errorMode === 'local'
        console.log('结束矿池')
        if (this.checkNetwork({ silent: locallyOwnedError }) === false) {
            if (locallyOwnedError) throw createDisplayError(this.getNetworkErrorMessage())
            return false
        }
        this.setState({
            stopRewardLoading: true
        })

        try {
            const p = await this.initProvider(true)
            const a = new ethers.Contract(this.state.contract, MiningPoolAbi, p.getSigner())
            const plan = buildStopRewardPlan()
            const tx = await a[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            const successInfo = {
                title: this.props.t('矿池停止成功'),
                description: this.props.t('当前矿池已停止继续发放奖励。'),
                ...result,
            }
            if (!locallyOwnedError) this.showTransactionSuccess(successInfo)
            this.fetchData()
            return successInfo
        } catch (e) {
            if (!locallyOwnedError) this.handleErr(e)
            throw e
        } finally {
            this.setState({
                stopRewardLoading: false
            })
        }
    }

    showMessageModal(info) {
        this.setState({
            swalProps: {
                show: false,
                title: '',
                text: '',
            }
        }, () => {
            this.setState({
                swalProps: {
                    ...info
                }
            })
        })

    }



    getLockTimeString(time) {
        const t = parseInt(time)
        const day = Math.floor(t / 86400)
        const hour = Math.floor((t - day * 86400) / 3600)
        const minute = Math.floor((t - day * 86400 - hour * 3600) / 60)
        const second = t - day * 86400 - hour * 3600 - minute * 60
        return `${day > 0 ? (day + this.props.t('天')) : ''} ${hour > 0 ? (hour + this.props.t('小时')) : ''} ${minute > 0 ? (minute + this.props.t('分钟')) : ''} ${second > 0 ? (second + this.props.t('秒')) : ''}`
    }

    generateShareLink() {
        // http://localhost:3000/#/core/0x928D87B7c6Ea72a44E86d72990d199C9905202f9?invitor=0x928D87B7c6Ea72a44E86d72990d199C9905202f9
        return `${this.state.urlPath}?invitor=${this.props.account}`
    }

    showTransactionSuccess(info) {
        this.setState({
            swalProps: {
                show: true,
                variant: 'transaction-success',
                wallet: this.state.account,
                chainId: this.state.chainId,
                ...info,
            }
        })
    }

    handleNftStakeSuccess(info) {
        this.setState({ showStakeModal: false }, () => {
            this.showTransactionSuccess(info)
            this.fetchData()
        })
    }

    openProjectInfo() {
        if (this.checkNetwork() === false || !this.ipfsPanelRef) return
        this.ipfsPanelRef.setIpfsInfo({ ...this.state.ipfsInfo }).then(() => this.setState({ showIpfsPanel: true }))
    }

    openInviteSettings() {
        if (this.checkNetwork() === false) return
        if (this.state.poolInfo.inviterSupported === false) {
            this.showMessageModal({
                show: true,
                title: this.props.t('当前矿池不支持推广邀请'),
                text: this.props.t('当前 NFT 矿池合约未实现推广邀请功能，无法开启。'),
            })
            return
        }
        this.setState({ showInviteConfirmModal: true })
    }

    openWhitelistSettings() {
        if (this.checkNetwork() === false) return
        this.setState({ showWhitelistModal: true })
    }

    copyPoolAddress() {
        if (this.checkNetwork() === false || typeof window === 'undefined') return
        this.copyValue(window.location.href)
    }

    canBindDomain() {
        const href = typeof window === 'undefined' ? '' : window.location.href
        return href.indexOf('fatsale') > -1 || href.indexOf('localhost') > -1
    }

    showDomainBindingInfo() {
        if (this.checkNetwork() === false || typeof window === 'undefined') return
        this.copyValue(window.location.href)
        this.showMessageModal({
            show: true,
            title: this.props.t('绑定独立域名'),
            html: `<div><p>${this.props.t('平台支持绑定独立域名并部署在单独的服务器中')}</p><p>${this.props.t('此功能需要自行购买域名, 并额外支付部署费用以及后续维护费用')}</p><p>${this.props.t('具体请咨询')} <a target="_blank" rel="noreferrer" href="https://t.me/safu_contract">${this.props.t('客服')}</a></p></div>`,
        })
    }

    showConsoleToast(message, tone = 'success') {
        this.setState({ consoleToast: { show: true, message, tone } })
    }

    copyValue(value, message = this.props.t('复制成功')) {
        if (!value) return
        copy(value)
        this.showConsoleToast(message)
    }

    async loadWalletNfts(fetchContext = this.getFetchContext()) {
        const { account, chainId } = fetchContext
        const nftAddress = this.state.nftAddress
        if (!account || !chainId || !nftAddress) {
            this.setStateForFetch(fetchContext, { walletNfts: [] })
            return []
        }
        try {
            if (!this.isFetchContextCurrent(fetchContext)) return []
            const provider = getSelectedWalletEthersProvider(chainId)
            const nft = new ethers.Contract(nftAddress, [
                'function balanceOf(address owner) view returns (uint256)',
                'function totalSupply() view returns (uint256)',
                'function tokensOfOwner(address owner) view returns (uint256[])',
                'function tokensOfOwnerIn(address owner, uint256 start, uint256 stop) view returns (uint256[])',
            ], provider)
            const { tokenIds } = await withRequestTimeout(loadOwnedTokenIds(nft, account))
            if (!this.isFetchContextCurrent(fetchContext)) return []
            const walletNfts = mapNftTokenIdList(tokenIds).map((id) => ({ id }))
            this.setStateForFetch(fetchContext, { walletNfts })
            return walletNfts
        } catch (error) {
            this.setStateForFetch(fetchContext, { walletNfts: [] })
            return []
        }
    }

    async loadStakedNfts(fetchContext = this.getFetchContext()) {
        const { account, chainId, contract } = fetchContext
        if (!account || !chainId || !contract) {
            this.setStateForFetch(fetchContext, { stakedNftIds: [], stakedNftsLoading: false })
            return []
        }
        this.setStateForFetch(fetchContext, { stakedNftsLoading: true })
        try {
            if (!this.isFetchContextCurrent(fetchContext)) return []
            const provider = getSelectedWalletEthersProvider(chainId)
            const pool = new ethers.Contract(contract, MiningPoolAbi, provider)
            const { tokenIds } = await withRequestTimeout(loadStakedTokenIds(pool, account, {
                shouldFallback: isOptionalInviterMethodUnavailable,
            }))
            const stakedNftIds = mapNftTokenIdList(tokenIds)
            if (!this.isFetchContextCurrent(fetchContext)) return []
            this.setStateForFetch(fetchContext, { stakedNftIds, stakedNftsLoading: false })
            return stakedNftIds
        } catch (error) {
            this.setStateForFetch(fetchContext, { stakedNftIds: [], stakedNftsLoading: false })
            return []
        }
    }

    async loadNftMetadataForIds(tokenIds, fetchContext = this.getFetchContext()) {
        const nftAddress = this.state.nftAddress
        const ids = [...new Set(mapNftTokenIdList(tokenIds))]
        if (!fetchContext.chainId || !nftAddress || ids.length === 0 || !this.isFetchContextCurrent(fetchContext)) {
            return {}
        }

        const provider = getSelectedWalletEthersProvider(fetchContext.chainId)
        const nft = new ethers.Contract(nftAddress, ['function tokenURI(uint256 tokenId) view returns (string)'], provider)
        const cachePrefix = `${fetchContext.chainId}:${nftAddress.toLowerCase()}:`
        const loadingEntries = {}

        ids.forEach((id) => {
            const cached = nftMetadataCache.get(`${cachePrefix}${id}`)
            loadingEntries[id] = cached || {
                ...shapeNftMetadata({ tokenId: id, payload: null }),
                metadataStatus: 'loading',
            }
        })
        this.setStateForFetch(fetchContext, {
            nftMetadataById: {
                ...(this.state.nftMetadataById || {}),
                ...loadingEntries,
            },
        })

        const results = await mapWithConcurrency(ids, 4, async (id) => {
            const cacheKey = `${cachePrefix}${id}`
            const cached = nftMetadataCache.get(cacheKey)
            if (cached) return cached

            try {
                const tokenUri = await withRequestTimeout(nft.tokenURI(id))
                if (!this.isFetchContextCurrent(fetchContext)) return null
                let payload = readInlineMetadata(tokenUri)
                if (!payload) {
                    const metadataUrl = normalizeNftUri(tokenUri)
                    if (!metadataUrl || metadataUrl.startsWith('data:image/')) {
                        throw new Error('Unsupported NFT metadata URI')
                    }
                    const response = await withRequestTimeout(fetch(metadataUrl))
                    if (!response.ok) throw new Error(`NFT metadata request failed: ${response.status}`)
                    payload = await response.json()
                }
                const metadata = shapeNftMetadata({ tokenId: id, payload })
                nftMetadataCache.set(cacheKey, metadata)
                return metadata
            } catch (_error) {
                return shapeNftMetadata({ tokenId: id, payload: null })
            }
        })

        if (!this.isFetchContextCurrent(fetchContext)) return {}
        const metadataById = results.reduce((accumulator, metadata) => {
            if (metadata) accumulator[metadata.id] = metadata
            return accumulator
        }, {})
        this.setStateForFetch(fetchContext, {
            nftMetadataById: {
                ...(this.state.nftMetadataById || {}),
                ...metadataById,
            },
        })
        return metadataById
    }

    async addManualNft(tokenId, fetchContext = this.getFetchContext()) {
        const parsed = parseManualNftTokenId(tokenId)
        if (!parsed.valid) {
            if (this.isFetchContextCurrent(fetchContext)) {
                this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('请输入有效的Token ID') })
            }
            return false
        }
        if (!fetchContext.account || !fetchContext.chainId || !this.state.nftAddress || !this.isFetchContextCurrent(fetchContext)) {
            return false
        }
        try {
            const provider = getSelectedWalletEthersProvider(fetchContext.chainId)
            const nftAddress = this.state.nftAddress
            const nft = new ethers.Contract(nftAddress, ['function ownerOf(uint256 tokenId) view returns (address)'], provider)
            const owner = await nft.ownerOf(parsed.tokenId)
            if (!this.isFetchContextCurrent(fetchContext)) return false
            if (!isManualNftOwner({ owner, wallet: fetchContext.account })) {
                this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('您不是此NFT的持有者') })
                return false
            }
            const existingNfts = [...(this.state.walletNfts || []), ...(this.state.manualNfts || [])]
            if (isDuplicateManualNft({ tokenId: parsed.tokenId, existingNfts })) {
                void this.loadNftMetadataForIds([parsed.tokenIdString], fetchContext)
                return {
                    tokenId: parsed.tokenIdString,
                    alreadyListed: true,
                }
            }
            this.setStateForFetch(fetchContext, {
                manualNfts: [...(this.state.manualNfts || []), { id: parsed.tokenIdString, isCustom: true }],
            })
            void this.loadNftMetadataForIds([parsed.tokenIdString], fetchContext)
            return {
                tokenId: parsed.tokenIdString,
                alreadyListed: false,
            }
        } catch (error) {
            if (this.isFetchContextCurrent(fetchContext)) {
                this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('验证失败，请检查Token ID是否正确') })
            }
            return false
        }
    }

    async openNftStake(tokenId) {
        if (this.checkNetwork() === false || !this.stakeModalRef) return false
        await this.stakeModalRef.setApproveInfo({
            chainId: this.state.chainId,
            miningContract: this.state.contract,
            nftAddress: this.state.nftAddress,
            tokenId,
        })
        await new Promise((resolve) => this.setState({ showStakeModal: true }, resolve))
        return this.stakeModalRef.handleLogic()
    }

    async claimReward() {
        if (this.checkNetwork() === false) return false
        if (!this.state.poolInfo.pendingReward || this.state.poolInfo.pendingReward === '0') {
            this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('暂无可领取奖励') })
            return false
        }
        this.setState({ reawardLoading: true })
        try {
            const provider = getSelectedWalletEthersProvider(this.state.chainId)
            const pool = new ethers.Contract(this.state.contract, MiningPoolAbi, provider.getSigner())
            const plan = buildNftClaimPlan()
            const tx = await pool[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            this.showTransactionSuccess({
                title: this.props.t('领取奖励成功'),
                description: this.props.t('奖励代币已发送至当前钱包。'),
                amount: formatTokenAmount(this.state.poolInfo.pendingReward, this.state.rewardTokenInfo.decimals),
                symbol: this.state.rewardTokenInfo.symbol,
                amountLabel: this.props.t('领取数量'),
                ...result,
            })
            this.fetchData()
            return true
        } catch (error) {
            this.handleErr(error)
            return false
        } finally {
            this.setState({ reawardLoading: false })
        }
    }

    async unstakeNft(tokenId) {
        if (this.checkNetwork() === false || this.state.unstakingTokenIds[tokenId]) return false
        this.setState({ unstakingTokenIds: { ...this.state.unstakingTokenIds, [tokenId]: true } })
        try {
            const provider = getSelectedWalletEthersProvider(this.state.chainId)
            const pool = new ethers.Contract(this.state.contract, MiningPoolAbi, provider.getSigner())
            const plan = buildNftWithdrawPlan(tokenId)
            const tx = await pool[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            await this.loadStakedNfts()
            this.fetchData()
            this.showTransactionSuccess({
                title: this.props.t('解除质押成功'),
                description: this.props.t('NFT 已返回当前钱包。'),
                amount: `#${tokenId}`,
                symbol: 'NFT',
                amountLabel: this.props.t('Token ID'),
                ...result,
            })
            return true
        } catch (error) {
            this.handleErr(error)
            return false
        } finally {
            this.setState({ unstakingTokenIds: { ...this.state.unstakingTokenIds, [tokenId]: false } })
        }
    }

    async emergencyWithdraw() {
        if (this.checkNetwork() === false) return false
        this.setState({ emergencyWithdrawLoading: true })
        try {
            const provider = getSelectedWalletEthersProvider(this.state.chainId)
            const pool = new ethers.Contract(this.state.contract, MiningPoolAbi, provider.getSigner())
            const plan = buildEmergencyWithdrawPlan()
            const tx = await pool[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            this.fetchData()
            this.showTransactionSuccess({
                title: this.props.t('紧急撤离成功'),
                description: this.props.t('全部已质押 NFT 已优先返回当前钱包，未领取奖励已放弃。'),
                ...result,
            })
            return true
        } catch (error) {
            this.handleErr(error)
            return false
        } finally {
            this.setState({ emergencyWithdrawLoading: false })
        }
    }

    render() {

        document.title = this.props.t('质押挖矿') + ' | Fatsale'
        const message = this.state.swalProps || {}
        return (
            <section className="staking-area">
                {message.variant === 'transaction-success'
                    ? <TransactionSuccessDialog {...message} t={this.props.t} onClose={() => this.setState({ swalProps: { ...message, show: false } })} />
                    : <ConsoleDialog show={Boolean(message.show)} onClose={() => this.setState({ swalProps: { ...message, show: false } })} closeLabel={this.props.t('关闭')} title={message.title || this.props.t('提示')} icon={message.icon === 'success' ? 'fa-check' : 'fa-exclamation-triangle'} tone={message.icon === 'success' ? 'default' : 'danger'} footer={<button type="button" className={`console-button ${message.icon === 'success' ? 'console-button--primary' : 'console-button--danger'}`} onClick={() => this.setState({ swalProps: { ...message, show: false } })}>{this.props.t('我知道了')}</button>}>
                        {message.html ? <div className="console-message-html" dangerouslySetInnerHTML={{ __html: message.html }} /> : <p className="console-message-text">{message.text}</p>}
                    </ConsoleDialog>}
                <ConsoleToast {...this.state.consoleToast} closeLabel={this.props.t('关闭')} onClose={() => this.setState({ consoleToast: { ...this.state.consoleToast, show: false } })} />
                <WhitelistModal
                    poolAddress={this.state.contract}
                    chainId={this.state.chainId}
                    show={this.state.showWhitelistModal}
                    handleClose={() => {
                        this.setState({
                            showWhitelistModal: false
                        })
                    }}
                    ok={(result) => {
                        this.fetchData()
                        this.setState({
                            showWhitelistModal: false
                        })
                        this.showTransactionSuccess(result)
                    }}
                />
                <StakeModal
                    onRef={node => this.stakeModalRef = node}
                    chainId={this.state.chainId}
                    show={this.state.showStakeModal}
                    handleClose={() => this.setState({ showStakeModal: false })}
                    ok={(result) => this.handleNftStakeSuccess(result)}
                />
                <InviteConfirmModal
                    invitorRewardPercentList={this.state.poolInfo?.invitorRewardPercentList}
                    fee={this.state.poolInfo.feeOfOpenInviter}
                    poolAddress={this.state.contract}
                    chainId={this.state.chainId}
                    show={this.state.showInviteConfirmModal}
                    open={this.state.poolInfo.enableInvitor}
                    handleClose={() => {
                        this.setState({
                            showInviteConfirmModal: false
                        })
                    }}
                    ok={(result) => {
                        this.fetchData()
                        this.setState({
                            showInviteConfirmModal: false
                        })
                        this.showTransactionSuccess(result)
                    }}
                />
                <IpfsPanel onRef={node => this.ipfsPanelRef = node} handleClose={() => {
                    this.setState({
                        showIpfsPanel: false
                    })
                }} info={this.state.ipfsInfo} contract={this.state.contract} chainId={this.state.chainId} show={this.state.showIpfsPanel} ok={(result) => {
                    // 调用合约
                    this.fetchData()
                    this.setState({
                        showIpfsPanel: false
                    })
                    this.showTransactionSuccess(result)
                }} />

                <NftStakingConsole controller={this} />
            </section >
        );
    }
}

// export default StakingOne;

function mapStateToProps(state) {
    const { account, chainId } = state;
    return {
        account,
        chainId
        // text
    };
}

// export default ProjectSingle;
export default connect(mapStateToProps)(withTranslation()(StakingOne))
